import(/* webpackMode: "eager", webpackExports: ["MainContent"] */ "/usr/src/app/components/pages/GlobalMainContent.tsx");
